<footer class="footer-bar">
  <div class="rights">
    <p>Made with 💖 by Manasvi Medam</p>
  </div>

  <ul class="contacts">
    <li>
      <a
        href="https://github.com/manasvimedam?tab=repositories"
        id="git-hub"
        target="_blank"
        ><i class="fab fa-github fa-2x"></i
      ></a>
    </li>
    <li>
      <a
        href="https://www.linkedin.com/in/manasvimedam"
        id="linked-in"
        target="_blank"
        ><i class="fab fa-linkedin-in fa-2x"></i
      ></a>
    </li>
    <li>
      <a href="mailto:manasvimedam26@gmail.com" id="e-mail" target="_blank"
        ><i class="fas fa-envelope-open-text fa-2x"></i
      ></a>
    </li>
  </ul>
</footer>
